module.exports = __webpack_public_path__ + "fonts/8adc24ddf009889a550cdf3c35b2cd1d.svg";